import { FetchResult } from "@apollo/client";

import { publishNodeInput, PublishNodeMutation } from "../../API";
import { IDeviceTableRow } from "../../pages/devices/hooks/useDeviceTableRows";
import { extractDeviceNameFromId } from "../utils/getEntityName";
import {
  errorNotification,
  successNotification,
} from "../variables/notification";

export const captureKeyframe = async (
  deviceDetail: IDeviceTableRow,
  publishNode: (
    args: publishNodeInput
  ) => Promise<
    FetchResult<
      PublishNodeMutation,
      Record<string, string>,
      Record<string, string>
    >
  >
): Promise<void> => {
  const { extractedDeviceName } = extractDeviceNameFromId(deviceDetail?.rowId);

  try {
    const response = await publishNode({
      message: JSON.stringify({
        ACTION: "SAVE_IMAGE",
        s3_key: deviceDetail?.deviceData?.keyFrame,
        TARGET: "CAMERA_MANAGER",
        device_id: extractedDeviceName,
        ACK: deviceDetail?.node.id,
      }),
      nodeId: deviceDetail?.node.id ?? "",
    });

    if (response.data) {
      successNotification("A new key image is captured");
    }
  } catch (error) {
    errorNotification("Something went wrong, a new key image isn't captured");

    console.error(error);
  }
};
